import React, {useEffect, useState} from "react";
import { useSpring, animated } from "react-spring";
import {Link} from "gatsby";

const ArrowLink = React.forwardRef((
  {
    className = "",
    to = "/",
    theme = "default",
    text = "",
    isLink = true,
    isExternalLink = false,
    isAnimation = false,
    transitionDuration = 300,
  },
  ref
) => {
  const [isStateAnimation, setStateAnimation] = useState(isAnimation);

  useEffect(() => {
    setStateAnimation(isAnimation);
  }, [isAnimation])

  const { x } = useSpring(
    {
      config:
        {
          duration: transitionDuration,
        },
      x: isStateAnimation ? 1 : 0
  });

  const mouseEnterHandler = () => {
    setStateAnimation(true);
  }

  const mouseLeaveHandler = () => {
    setStateAnimation(false);
  }

  return (
    <>
      {isLink ? (
        <>
          {!isExternalLink ? (
            <Link
              to={to}
              className={`arrow-link arrow-link--${theme} ${className}`}
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
              ref={ref}
            >
              <span className="arrow-link__text">{text}</span>
              <span className="arrow-link__icon-wrapper">
                <svg
                  className="arrow-link__icon"
                  width="60px"
                  height="10px"
                >
                  <animated.path
                    d={x.to({
                      range: [0, 1],
                      output: [
                        "M7.92757 10.001L6.85436 8.93351L10.0942 5.70088L7.51855e-07 5.70088L1.01421e-06 4.20037L10.1044 4.1903L6.94548 1.05838L8.01869 0.000977965L13 4.93552L7.92757 10.001Z",
                        "M54.9276 10.2393L53.8544 9.1718L57.0942 5.93917L7.51854e-07 5.93916L1.01421e-06 4.43866L57.1044 4.42859L53.9455 1.29667L55.0187 0.239267L60 5.17381L54.9276 10.2393Z",
                      ],
                    })}
                  />
                </svg>
              </span>
            </Link>
          ) : (
            <a
              className={`arrow-link arrow-link--${theme} ${className}`}
              href={to}
              target="_blank"
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
              ref={ref}
            >
              <span className="arrow-link__text">{text}</span>
              <span className="arrow-link__icon-wrapper">
                <svg
                  className="arrow-link__icon"
                  width="60px"
                  height="10px"
                >
                  <animated.path
                    d={x.to({
                      range: [0, 1],
                      output: [
                        "M7.92757 10.001L6.85436 8.93351L10.0942 5.70088L7.51855e-07 5.70088L1.01421e-06 4.20037L10.1044 4.1903L6.94548 1.05838L8.01869 0.000977965L13 4.93552L7.92757 10.001Z",
                        "M54.9276 10.2393L53.8544 9.1718L57.0942 5.93917L7.51854e-07 5.93916L1.01421e-06 4.43866L57.1044 4.42859L53.9455 1.29667L55.0187 0.239267L60 5.17381L54.9276 10.2393Z",
                      ],
                    })}
                  />
                </svg>
              </span>
            </a>
          )}
        </>
      ) : (
        <span
          className={`arrow-link arrow-link--${theme} ${className}`}
          ref={ref}
        >
          <span className="arrow-link__text">{text}</span>
          <span className="arrow-link__icon-wrapper">
            <svg
              className="arrow-link__icon"
              width="60px"
              height="10px"
            >
              <animated.path
                d={x.to({
                  range: [0, 1],
                  output: [
                    "M7.92757 10.001L6.85436 8.93351L10.0942 5.70088L7.51855e-07 5.70088L1.01421e-06 4.20037L10.1044 4.1903L6.94548 1.05838L8.01869 0.000977965L13 4.93552L7.92757 10.001Z",
                    "M54.9276 10.2393L53.8544 9.1718L57.0942 5.93917L7.51854e-07 5.93916L1.01421e-06 4.43866L57.1044 4.42859L53.9455 1.29667L55.0187 0.239267L60 5.17381L54.9276 10.2393Z",
                  ],
                })}
              />
            </svg>
          </span>
        </span>
      )}
    </>
  )
})

export default ArrowLink
